import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    linkWrapper?: InjectableCss;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
        `,
    },
    linkWrapper:{
        css:css`
            span{
            font-family: "Roboto-Medium";
            font-size: 13px;
            }
           >div{
            justify-content: center;
            display: flex;
            align-items: center;
                >span{
                    height: 16px;
                    width: 16px;
                    background-color: ${getColor("primary")};
                    border-radius: 50%;
                    padding: 2px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    svg{
                    height:11px;
                    width:11px;
                    }
                    path{
                    stroke: #ffffff;}
                }
            }
           
        `
    }
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }
    const callForPricing = product.properties?.isCallForPricing?.toLowerCase() === "true";
    return (
        <>
            {!callForPricing && (
                <StyledWrapper {...styles.linkWrapper}>
                    <ProductAddToListLink data-test-selector="productDetails_addToList"  />
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAddToListLink)),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
